import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const TONE_CLASSES = {
	ok: 'tw:bg-ok-soft tw:text-ok',
	warn: 'tw:bg-warn-soft tw:text-warn',
	danger: 'tw:bg-danger-soft tw:text-danger',
	neutral: 'tw:bg-surface-3 tw:text-ink-2',
	accent: 'tw:bg-accent-soft tw:text-accent-ink',
};

/**
 * `.pill` from the entity-list spec — optionally with the leading status dot.
 * Measured live on the reference mock as JetBrains Mono 11px/600 (not the
 * written spec's Inter 11.5px) — following the measured value per instruction.
 */
function Pill({ tone = 'neutral', dot = false, children }) {
	return (
		<span
			className={classnames(
				'tw:inline-flex tw:items-center tw:gap-1.5 tw:rounded-full tw:px-2.5 tw:py-0.5 tw:font-mono tw:text-[11px] tw:font-semibold tw:tracking-[0.01em]',
				TONE_CLASSES[tone],
			)}
		>
			{dot && <span className='tw:w-1.5 tw:h-1.5 tw:rounded-full tw:bg-current' />}
			{children}
		</span>
	);
}

Pill.propTypes = {
	tone: PropTypes.oneOf(['ok', 'warn', 'danger', 'neutral', 'accent']),
	dot: PropTypes.bool,
	children: PropTypes.node,
};

export default Pill;
